// extracted by mini-css-extract-plugin
module.exports = {"ToolsNav":"ToolsHeader_ToolsNav__ejHlI"};